<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  // overflow: auto;
  // width: calc(100% - 40px);
  min-width: 500px;

  .box {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;

    .sign {
      position: static;
      width: 5px;
      height: 16px;
      left: 0px;
      top: 3px;
      background: #419fff;
      flex: none;
      order: 0;
      flex-grow: 0;
      // margin: 0px 10px;
    }

    .total {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;

      .text {
        font-family: Microsoft YaHei UI;
        color: #303133;
        font-size: 16px;
        margin-left: 12px;
        // font-family: 'Microsoft YaHei UI';
        // font-weight: 400;
      }

      .num {
        font-family: D-DIN Exp;
        margin-left: 36px;
        color: #606266;
        font-size: 24px;
      }

      .unit {
        margin-left: 8px;
        color: #909399;
        font-family: Microsoft YaHei UI;
        font-size: 12px;
      }
    }
  }

  .chart-box {
    border: 1px solid #e4e7ed;
    position: absolute;
    width: 830px;
    height: 271px;
    left: 24px;
    top: 152px;

    .title {
      font-size: 16px;
      line-height: 22px;
      color: #303133;
      font-family: Microsoft YaHei UI;
      margin: 20px 20px;
    }

    .box {
      .chart {
        position: absolute;
        width: 800px;
        height: 155px;
        margin-left: -70px;
        top: 78px;
      }
    }
  }

  // 图表
  .echart-box {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 1118px;
    min-height: 215px;

    // background-color: red;
    .echart-box-line {
      width: 12px;
      height: 100%;
    }

    .echart-box-item {
      flex: 1;
      min-width: 553px;
      min-height: 215px;
      border: 1px solid #e4e7ed;

      .echart-box-title {
        width: 100%;
        padding-top: 20px;
        padding-left: 20px;
        // padding-bottom: 16px;
        color: #303133;
        font-size: 16px;
      }

      .echart-box-info {
        width: 100%;
        height: 100%;
        min-height: 173px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .echart {
          flex: 2;
        }

        .info {
          flex: 1;
          height: 100%;
          min-height: 173px;
          padding-top: 20px;
          padding-right: 40px;
          padding-bottom: 39px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          width: 100%;

          .info-item {
            width: 100%;
            color: #909399;
            font-size: 14px;

            .text {
              margin-left: 30px;
              color: #419fff;
              font-size: 18px;
              font-family: D-DIN Exp;
            }

            .text1 {
              margin-left: 30px;
              color: #303133;
              font-size: 18px;
              font-family: D-DIN Exp;
            }

            .text2 {
              margin-left: 6px;
              color: #909399;
              font-size: 12px;
              font-family: Microsoft YaHei UI;
            }

            .text3 {
              margin-left: 30px;
              color: #303133;
              font-size: 14px;
              font-family: Microsoft YaHei UI;
            }

            .text4 {
              // margin-left: 12px;
              color: #419fff;
              font-size: 18px;
              font-family: D-DIN Exp;
            }
          }
        }
      }
    }
  }

  // 表格
  .table {
    width: 100%;
    margin-top: 12px;

    .main {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      padding: 5px;
      color: #909399;

      .item {
        width: 50%;
        padding: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .label {
          width: 60%;
        }
      }
    }
  }
}
</style>

<template>
  <div style="display: inline;">
    <div class="container">
      <!-- 搜索表单 -->
      <div class="form-container">
        <el-form :model="conditions" :inline="true" size="mini">
          <el-form-item :label="$t('tongjishijian')">
            <yi_time_input :format="'yyyy-MM-dd'" :maxTime="31 * 24 * 3600 * 1000" type="daterange" ref="yiTime" :start.sync="conditions.begin" :end.sync="conditions.end"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="conditions.orgId" :key="key"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDowntimeReport" plain>{{ $t('sousuo') }} </el-button>
            <el-button type="default" @click="resetDowntimeReport" plain style="margin-left: 10px;">
              {{ $t('chongzhi') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 设备停机总时长 -->
      <div class="box">
        <div class="sign"></div>
        <div class="total">
          <div class="text">{{ $t('shebeitingjizongshichang') }}</div>
          <div class="num">
            {{ totalTime.toFixed(1) }}
          </div>
          <div class="unit">
            {{ $t('xiaoshi') }}
          </div>
        </div>
      </div>
      <!-- 图表 -->
      <div class="echart-box">
        <!-- 停机设备分布（小时） -->
        <div class="echart-box-item">
          <div class="echart-box-title">
            {{ $t('tingjishebeifenbubiao (xiaoshi)') }}
          </div>
          <div class="echart-box-info" v-if="tableData.length > 0">
            <div class="echart">
              <div style="width:470px;height:133px;" id="leftApp"></div>
            </div>
            <div class="info">
              <div class="info-item" v-if="leftEchart.equipmentName !== ''">
                <span>{{ $t('tingjizuichangshebei') }}</span>
                <span class="text">{{ leftEchart.equipmentName }}</span>
              </div>
              <div class="info-item" v-if="leftEchart.time !== ''">
                <span style="min-width: 85px">{{ $t('leijitingjishichang') }}</span>
                <span class="text1">{{ leftEchart.time.toFixed(1) }}</span>
                <span class="text2">{{ $t('xiaoshi') }}</span>
              </div>
              <div class="info-item" style="display:flex;justify-content:flex-start;align-item:center;flex-wrap:nowrap">
                <span style="min-width: 85px">{{ $t('tingjiyuanyinzuiduo') }}</span>
                <div class="text3">
                  <span>{{ $t(leftEchart.reasonTypeName) }}</span>
                  <span v-if="(leftEchart.reason && leftEchart.reasonTypeName) !== ''">-</span>
                  <span>{{ $t(leftEchart.reason) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="echart-box-line"></div>
        <!-- 停机设备分布表 -->
        <div class="echart-box-item">
          <div class="echart-box-title">
            {{ $t('tingjiyuanyinfenbubiao') }}
          </div>
          <div class="echart-box-info" v-if="tableData.length > 0">
            <div class="echart">
              <div style="width:470px;height:133px" id="rightApp"></div>
            </div>
            <div class="info">
              <div class="info-item" style="display:flex;justify-content:flex-start;align-item:center;flex-wrap:nowrap">
                <div style="min-width: 85px">{{ $t('zuiduotingjiyuanyin') }}</div>
                <div class="text3">
                  <span>{{ $t(rightEchart.reasonTypeName) }}</span>
                  <span v-if="(rightEchart.reason && rightEchart.reasonTypeName) !== ''">-</span>
                  <span>{{ $t(rightEchart.reason) }}</span>
                </div>
              </div>
              <div class="info-item">
                <span>{{ $t('tingjiyuanyinzhanbi') }}</span>
                <span class="text1">{{ rightEchart.ratio }}</span>
              </div>
              <div class="info-item" v-if="rightEchart.equipmentName !== ''">
                <span>{{ $t('bizhongzuigaoshebei') }}</span>
                <span class="text">{{ rightEchart.equipmentName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="table">
        <!--        :data="currentTableData"-->
        <el-table stripe max-height="600" size="mini" border style="width: 100%" :data="currentTableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px', 'font-size': '14px' }" @header-dragend="headerDragend" v-loading="searchLoading">
          <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :label="$t(item.label)" :sortable="item.sortable" :width="item.width" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <template v-if="item.prop === 'source'">
                {{ $t(store.state.dictJsonAll['COMMON_GEN_SOURCE'][scope.row.source]) }}
              </template>
              <template v-else-if="item.prop === 'reasonName'">
                {{ $t(scope.row.reasonName) }}
              </template>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right;margin-top: 8px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handleCurrentChange" @next-click="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total,prev, pager, next,sizes" :total="currentTableData.length"> </el-pagination>
        </div>
        <!--				 <div style="margin-bottom: 30px;"></div>-->
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
const date = new Date();
const end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59).getTime();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();

export default {
  name: 'web_report_shutdown_list',
  data() {
    return {
      searchLoading: false,
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      conditions: {
        begin: begin,
        end: end,
        orgId: ''
      },
      dataList: [],
      equipmentPieList: [],
      tableData: [],
      reasonPieList: [],
      currentTableData: [],
      tableColumn: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName',
          width: '120',
          sortable: false
        },
        {
          label: 'laiyuan',
          prop: 'source',
          // width: '180',
          sortable: false
        },
        {
          label: 'kaishishijian',
          prop: 'startTime',
          width: '180',
          sortable: false
        },
        {
          label: 'jieshushijian',
          prop: 'endTime',
          width: '180',
          sortable: false
        },
        {
          label: 'wuzuoyeshijian (xiaoshi)',
          prop: 'totalTime',
          width: '180',
          sortable: false
        },
        {
          label: 'rengongquerenshijian (xiaoshi)',
          prop: 'manualTime',
          width: '180',
          sortable: false
        },
        {
          label: 'yuanyin',
          prop: 'reasonName',
          width: '220',
          sortable: false
        }
      ],
      key: 0,
      totalTime: 0, // 设备停机总时长
      leftEchart: {
        equipmentName: '',
        time: '',
        reason: ''
      },
      rightEchart: {
        equipmentName: '',
        ratio: '',
        reason: ''
      }
    };
  },
  watch: {
    'this.tableData': {
      handler(n) {
        console.log('tablefffffffffffffff', n);
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      this.conditions.orgId = this.store.state.organizations[0].id;
      this.getDowntimeReport();
    }, 300);
  },

  computed: {
    tableColumn() {
      const column = this.tableColumn;
      const name = 'web_report_shutdown_list';
      let colwidths = {};
      if (window.localStorage.getItem('colwidth_' + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem('colwidth_' + name));
        } catch (e) {
          window.localStorage.removeItem('colwidth_' + name);
        }
      }
      if (column.length > 0) {
        for (const i in column) {
          if (colwidths[this.$t(column[i]['label'])] !== undefined) {
            this.$set(column[i], 'width', colwidths[this.$t(column[i]['label'])]);
          }
        }
      }
      return column;
    }
  },
  methods: {
    // 页面切换方法
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    //条数切换
    handleSizeChange(value) {
      this.pageSize = value;
      this.getDowntimeReport();
    },
    headerDragend(newWidth, oldWidth, column, event) {
      const name = 'web_report_shutdown_list';
      let colwidths = {};
      if (window.localStorage.getItem('colwidth_' + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem('colwidth_' + name));
        } catch (e) {
          window.localStorage.removeItem('colwidth_' + name);
        }
      }
      if (column.label == '' || column.label == null) {
        return;
      }
      colwidths[column.label] = column.width;
      window.localStorage.setItem('colwidth_' + name, JSON.stringify(colwidths));
    },
    // 重置
    resetDowntimeReport() {
      this.conditions = {
        begin: begin,
        end: end,
        orgId: ''
      };
      ++this.key;
      this.$nextTick(() => {
        this.conditions.orgId = this.store.state.organizations[0].id;
        this.$nextTick(() => {
          this.getDowntimeReport();
        });
      });
      this.currentTableData = undefined;
    },
    // 搜索
    getDowntimeReport() {
      this.searchLoading = true;
      this.currentPage = 1;
      let requestParam = {
        ...this.conditions,
        orderBy: 'startTime'
      };
      return this.http
        .get('/web/report/exception?' + this.qs.stringify(requestParam))
        .then(response => {
          const data = response.data;
          // this.dataList = data
          // 表格
          this.totalTime = data.extend.totalTime || 0;
          this.tableData = data.rows;
          this.currentTableData = data.rows;
          if (this.tableData.length > 0) {
            this.equipmentPieList = data.extend.equipmentPie.pie;
            this.reasonPieList = data.extend.reasonPie.pie;
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i]['startTime'] = this.dateFormat(this.tableData[i]['startTime']);
              this.tableData[i]['endTime'] = this.dateFormat(this.tableData[i]['endTime']);
              this.tableData[i]['totalTime'] = (this.tableData[i]['totalTime'] / 3600).toFixed(1);
              this.tableData[i]['manualTime'] = (this.tableData[i]['manualTime'] / 3600).toFixed(1);
            }
            // 左侧图表
            if (data.extend.equipmentPie) {
              this.leftEchart.equipmentName = data.extend.equipmentPie.longest || '';
              this.leftEchart.time = data.extend.equipmentPie.times || '';
              this.leftEchart.reason = data.extend.equipmentPie.maxReason.reasonName || '';
              this.leftEchart.reasonTypeName = data.extend.equipmentPie.maxReason.typeName || '';
              if (data.extend.equipmentPie.pie) {
                const leftPieData = data.extend.equipmentPie.pie.map(item => {
                  return {
                    name: this.$t(item.equipmentName),
                    value: (item.count / 3600).toFixed(1),
                    code: item.equipmentName
                  };
                });
                this.$nextTick(() => {
                  this.drawLeftChart(leftPieData);
                });
              }
            } else {
              this.leftEchart.equipmentName = '';
              this.leftEchart.time = '';
              this.leftEchart.reason = '';
              this.leftEchart.reasonTypeName = '';
              this.$nextTick(() => {
                this.drawLeftChart([]);
              });
            }
            // 右侧图表
            if (data.extend.reasonPie) {
              console.log('6666', data.extend.reasonPie);
              this.rightEchart.equipmentName = data.extend.reasonPie.highest ? data.extend.reasonPie.highest.join(' ') : '';
              this.rightEchart.reason = data.extend.reasonPie.longest.reasonName ? data.extend.reasonPie.longest.reasonName : '';

              this.rightEchart.reasonTypeName = data.extend.reasonPie.longest.typeName ? data.extend.reasonPie.longest.typeName : '';
              this.rightEchart.ratio = (data.extend.reasonPie.ratio * 100).toFixed(1) + '%';

              if (data.extend.reasonPie.pie) {
                const rightPieData = data.extend.reasonPie.pie.map(item => {
                  return {
                    name: this.$t(item.reasonName),
                    value: (item.count / 3600).toFixed(1),
                    code: item.reasonName
                  };
                });
                this.$nextTick(() => {
                  this.drawRightChart(rightPieData);
                });
              }
            } else {
              this.rightEchart.equipmentName = '';
              this.rightEchart.reason = '';
              this.rightEchart.reasonTypeName = '';
              this.rightEchart.ratio = 0 + '%';
              this.$nextTick(() => {
                this.drawRightChart([]);
              });
            }
          }
        })
        .catch(error => {
          this.$message.error(error);
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d h:i:s';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    },
    // 停机设备分布（小时）
    drawLeftChart(data) {
      if (!document.getElementById('leftApp')) {
        return;
      }
      console.log('cccjjjj', data);
      let myChart = this.echarts.getInstanceByDom(document.getElementById('leftApp'));
      if (myChart == null) {
        myChart = this.echarts.init(document.getElementById('leftApp'));
      }
      let option = {
        color: ['#76B8FE', '#B09BFE', '#EFA1C5', '#EFE7A1', '#EFBDA1', '#E5E5E5', '#e7bcf3', '#8378ea'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}小时 ({d}%)'
        },
        toolbox: {
          show: true
        },
        legend: {
          itemlength: 8,
          itemWidth: 8,
          orient: 'vertical',
          align: 'left',
          left: '33%',
          icon: 'circle',
          textStyle: {
            color: '#909399'
          }
        },
        series: [
          {
            label: {
              show: false
            },
            name: this.$t('shebeitingjifenbu'),
            type: 'pie',
            center: [80, 65],
            data: data
          }
        ]
      };
      if (data.length == 0) {
        myChart.clear();
        this.currentTableData = undefined;
      } else {
        myChart.setOption(option);
        myChart.on('click', this.clickLeftPie);
      }
    },
    // 停机原因分布表
    drawRightChart(data) {
      if (!document.getElementById('rightApp')) {
        return;
      }
      // console.log('drawRightChart', data)
      let myChart = this.echarts.getInstanceByDom(document.getElementById('rightApp'));
      if (myChart == null) {
        myChart = this.echarts.init(document.getElementById('rightApp'));
      }
      let option = {
        color: ['#76B8FE', '#B09BFE', '#EFA1C5', '#EFE7A1', '#EFBDA1', '#E5E5E5', '#e7bcf3', '#8378ea'],
        // let unit = %
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}小时 ({d}%)'
          // 	formatter: (data) => {
          // 		console.log(data)
          // 		return data.name + "<br/>"+ data.value+ " : " + data.unit;
          // },
        },
        toolbox: {
          show: true
        },
        legend: {
          itemlength: 8,
          itemWidth: 8,
          orient: 'vertical',
          left: '33%',
          align: 'left',
          icon: 'circle',
          textStyle: {
            color: '#909399'
          }
          // formatter: function(params) {
          // 	if (params.indexOf('\n') == -1) {
          // 		return params;
          // 	} else {
          // 		return '{white|' + params.split('\n')[0] + '}\n' + params.split('\n')[1];
          // 	}
          // }
        },
        series: [
          {
            label: {
              show: false
            },
            name: this.$t('shebeitingjifenbu'),
            type: 'pie',
            center: [80, 65],
            data: data
          }
        ]
      };
      if (data.length == 0) {
        myChart.clear();
        this.currentTableData = undefined;
      } else {
        myChart.setOption(option);
        myChart.on('click', this.clickRightPie);
      }
    },
    // 左侧图表点击
    clickLeftPie(param) {
      if (this.equipmentPieList.length > 5) {
        let list = this.equipmentPieList
          .filter((item, i) => {
            return i < 5;
          })
          .map(item => {
            return item.equipmentId;
          });
        this.currentTableData = this.tableData.filter(item => {
          if (param.data.code == 'exception_other') {
            return !list.contains(item.equipmentId);
          }
          return item.equipmentName === param.data.code;
        });
      } else {
        this.currentTableData = this.tableData.filter(item => {
          return item.equipmentName === param.data.code;
        });
      }

      this.currentPage = 1;
    },
    // 右侧图表点击
    clickRightPie(param) {
      if (this.reasonPieList.length > 5) {
        let list = this.reasonPieList
          .filter((item, i) => {
            return i < 5;
          })
          .map(item => {
            return item.reasonName;
          });
        this.currentTableData = this.tableData.filter(item => {
          if (param.data.code == 'exception_other') {
            return !list.contains(item.reasonName);
          }
          return item.reasonName === param.data.code;
        });
      } else {
        this.currentTableData = this.tableData.filter(item => {
          return item.reasonName === param.data.code;
        });
      }

      this.currentPage = 1;
    }
  }
};
</script>
